<template>
    <FilterLayout :advanceOption="false">
      <!-- <div class="mt-3">
        <h5 class="text-base font-normal leading-none text-theme-33">
          หัวข้อข่าว
        </h5>
      </div> -->
      <section data-test="filter-title-section">
        <div class="mt-2">
          <label class="from-label text-xxs text-gray-600" for="osm-select">หัวข้อข่าว</label>
          <input type="text" class="form-control" placeholder="หัวข้อข่าว" v-model="filterState.title" />
        </div>
      </section>
      <section data-test="filter-category-section">
        <div class="mt-2">
          <label class="from-label text-xxs text-gray-600" for="osm-select">ประเภทข่าว</label>
          <v-select
            data-test="category-select"
            id="category-select"
            v-model="filterState.category"
            :options="['เกี่ยวกับโครงการ','เกี่ยวกับระบบ','ข่าวสาร/ประกาศอื่น']"
            :clearable="true"
            placeholder="กรุณาเลือกประเภทข่าว"
            :appendToBody="true"
          >
            <template #no-options="">
              <p class="text-sm font-normal text-gray-500">
                ไม่พบข้อมูล
              </p>
            </template>
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
            </template>
          </v-select>
        </div>
      </section>
      <section data-test="filter-detail-section">
        <div class="mt-2">
          <label class="from-label text-xxs text-gray-600" for="osm-select">รายละเอียดโดยย่อ</label>
          <input type="text" class="form-control" placeholder="รายละเอียดโดยย่อ" v-model="filterState.short_detail" />
        </div>
      </section>
        <div class="flex justify-end mt-3">
            <button class="btn btn-outline-secondary mr-2" @click="resetState">
                ล้าง
            </button>
            <button class="btn btn-primary" @click="sendToStore">
                ค้นหา
            </button>
        </div>
    </FilterLayout>
</template>
<script setup>
import FilterLayout from "./layout/index.vue"
import { reactive, onMounted,} from "vue";
import { useStore } from "vuex";

const INIT_FILTER_VALUE = {
  title: null,
  category: null,
  short_detail: null
};

const store = useStore();
const filterState = reactive({ ...INIT_FILTER_VALUE });

onMounted(() => {
  Object.assign(
    filterState,
    JSON.parse(JSON.stringify(store.getters["newsFilter/getAllFilter"]))
  );
});


const resetState = () => {
  const initFilter = JSON.parse(JSON.stringify(INIT_FILTER_VALUE))
  Object.assign(filterState, initFilter);
};
const sendToStore = () => {
  store.dispatch(
    "newsFilter/setStore",
    JSON.parse(JSON.stringify(filterState))
  );
};


</script>